import React, { Component } from 'react';
import { Field, change } from 'redux-form';
import queryString from 'query-string';
import { Breadcrumb, Grid, Row, Col, Panel, ButtonToolbar, Button, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import _ from 'lodash';
import classNames from 'classnames';
import axios from 'axios';

import { InputField } from '../../Common/inputField';
import ContentWrapper from '../../Layout/ContentWrapper';
import Spinner from '../../../components/Widgets/spinner';
import { Selection, MultiSelection } from '../../Common/selection';
import { DatePicker } from '../../Common/datePicker';
import { formatDate } from '../../Common/dateFormat';
import APReceiveTable from './apReceiveTable';
import AccountDropdown from '../../AR/accountDropdown';
import PaymentMethodOptions from '../../Common/arapPaymentOptions';
import { numberWithCommas } from '../../Common/numberWithCommas';
import { AP_URL } from '../../../actions/url';

class CreateAP extends Component {
  state = {
    invoices: [],
    selectedInvoices: [],
    unpaidAmount: 0,
    totalAmount: 0,
    totalDiscount: 0,
    checkAuthorizeOpen: false,
    action: null,
    waiveAmount: 0,
    checkNumbers: [],
    checkNumbersInputHasWarning: false,
  }
  componentWillMount() {
    this.props.clearAPDetail();
    this.props.clearCredits();
    this.props.fetchVendors();
    const queryObj = queryString.parse(this.props.location.search);
    const vendId = queryObj.vend_id;
    if (vendId) {
      this.props.changeField('Vendor', parseFloat(vendId), 'createAP');
    }
    this.props.setDefaultOfForm('waiveAmount', 0.00, 'createAP');
    this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAP');
    this.getCheckNumbers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vendorID && nextProps.vendorID !== this.props.vendorID) {
      const fromDate = formatDate(this.props.fromDate);
      const toDate = formatDate(this.props.toDate);
      const invoiceDate = this.props.invoiceDate;
      this.props.fetchVendorDetail(nextProps.vendorID.value || nextProps.vendorID);
      this.props.fetchAPCredits(nextProps.vendorID.value || nextProps.vendorID);
      this.props.fetchAPInvoices(
        nextProps.vendorID.value || nextProps.vendorID,
        invoiceDate,
        fromDate,
        toDate
      );
    }
    if (nextProps.invoices && nextProps.invoices !== this.props.invoices) {
      const invoices = nextProps.invoices;
      const selectedInvoices = [];
      this.setState({ invoices, selectedInvoices });
    }
    if (nextProps.invoiceDate && nextProps.invoiceDate !== this.props.invoiceDate) {
      const fromDate = formatDate(this.props.fromDate);
      const toDate = formatDate(this.props.toDate);
      if (this.props.vendorID) {
        this.props.fetchAPInvoices(
          this.props.vendorID.value || this.props.vendorID,
          nextProps.invoiceDate,
          fromDate,
          toDate
        );
      }
    }

    if (!nextProps.invoiceDate) {
      this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAP');
    }

    if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
      const fromDate = formatDate(nextProps.fromDate);
      const toDate = formatDate(this.props.toDate);
      if (this.props.vendorID) {
        this.props.fetchAPInvoices(
          this.props.vendorID.value || this.props.vendorID,
          this.props.invoiceDate,
          fromDate,
          toDate
        );
      }
    }
    if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
      const fromDate = formatDate(this.props.fromDate);
      const toDate = formatDate(nextProps.toDate);
      if (this.props.vendorID && !this.props.apDetail) {
        this.props.fetchAPInvoices(
          this.props.vendorID.value || this.props.vendorID,
          this.props.invoiceDate,
          fromDate,
          toDate
        );
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { totalDiscount } = this.state;
    if (totalDiscount !== prevState.totalDiscount) {
      this.props.dispatch(change('createAP', 'Discount', parseFloat(totalDiscount).toFixed(2) || 0));
    }
  }

  getCheckNumbers() {
    axios.get(
      `${AP_URL}check_num/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      this.setState({
        checkNumbers: response.data,
      });
    });
  }

  getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');

  getVendorOptions(field) {
    const vendorOptions = [];
    this.props.vendors.map(vendor => {
      vendorOptions.push({ value: vendor.Vendor_id, label: vendor[field] });
    });
    return vendorOptions;
  }

  getBillingAddress() {
    const { currentVendorDetail } = this.props;
    let Address1 = '';
    let Address2 = '';
    if (currentVendorDetail && currentVendorDetail.Billing) {
      Address1 = currentVendorDetail.Billing.Street;
      Address2 = `${currentVendorDetail.Billing.City}, ${currentVendorDetail.Billing.State} ${currentVendorDetail.Billing.Zip}`;
    }
    return [Address1, Address2];
  }

  moveInvoices = (invoice, from) => {
    const { invoices, selectedInvoices } = this.state;
    let index;
    if (from === 'invoices') {
      index = _.findIndex(invoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
      if (index > -1) {
        invoices.splice(index, 1);
      }
      index = _.findIndex(selectedInvoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
      if (index === -1) {
        selectedInvoices.push(invoice);
      }
    } else if (from === 'selectedInvoices') {
      index = _.findIndex(selectedInvoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
      if (index > -1) {
        selectedInvoices.splice(index, 1);
      }
      index = _.findIndex(invoices, { WarehouseReceive_id: invoice.WarehouseReceive_id });
      if (index === -1) {
        delete invoice.DiscountedAmount;
        invoices.push(invoice);
      }
    }
    let totalAmount = 0;
    selectedInvoices.map(r => {
      totalAmount += parseFloat(r.UnpaidAmount) || 0;
    });
    this.setState({ invoices, selectedInvoices, totalAmount });
  }

  debouncedCreateAP = _.debounce((formProps, rows) => {
    this.props.createAP(formProps, rows).then(
      () => {
        if (this.props.apCreated && !this.props.apCreateError) {
          this.props.router.push('/AP');
        }
      }
    );
  }, 500, { maxWait: 1000 })

  handleFormSubmit = (formProps) => {
    // const formProps = {
    //   Vendor: this.props.vendorID,
    //   TotalPayment: parseFloat(this.props.totalPayment).toFixed(2),
    //   Method: this.props.method,
    //   CheckNum: this.props.checkNum,
    //   Account: this.props.account,
    //   Discount: parseFloat(this.props.discount),
    //   Note: this.props.note,
    //   // Waive: this.props.waive,
    //   WaiveAmount: parseFloat(this.state.waiveAmount).toFixed(2),
    //   TotalAmount: parseFloat(this.state.totalAmount).toFixed(2),
    // };
    const { rows } = this.selectedTable.state;
    this.debouncedCreateAP(formProps, rows);
  }

  handleWaiveInputChange = (event) => {
    this.setState({
      waiveAmount: event.target.value,
    });
  }

  handleDiscountCellChange = (rows) => {
    let totalDiscount = 0;
    let totalAmount = 0;
    rows.map(row => {
      totalDiscount += parseFloat(row.DiscountedAmount || 0);
      totalAmount += parseFloat(row.UnpaidAmount || 0);
    });
    this.setState({
      totalDiscount,
      totalAmount,
    });
  }

  renderInputField = (props) => {
    const { meta: { touched, error }, className } = props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    return (
      <div>
        <Input
          {...props.input}
          className={inputClass}
          type='text'
          onChange={(event) => {
            props.input.onChange(event);
          }}
          disabled={props.disabled}
        />
        {touched && error && <span className='parsley-error-message'>{error}</span>}
      </div>
    );
  }

  renderDatePicker(fieldName, placeholder) {
    return (
      <Button bsStyle='primary'>
        <Field name={fieldName} disabled={this.props.invoiceDate !== 'range'} placeholder={placeholder} component={DatePicker} />
      </Button>
    );
  }

  renderVendors() {
    if (this.props.vendorsIsLoading && !this.props.vendorsError) {
      return <Spinner />;
    } else if (this.props.vendorsError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const vendorNameOptions = this.getVendorOptions('Name'); // Return a JSON in the format of React-Select's options
    const vendorNumOptions = this.getVendorOptions('VendorNum');
    const vendorPhoneOptions = this.getVendorOptions('Telephone'); // Return a JSON in the format of React-Select's options
    const vendorDescOptions = this.getVendorOptions('Description');
    let billingAddress = ['', ''];
    const { vendorID, currentVendorDetail } = this.props;
    let contact = null;
    let phone = null;
    if (vendorID && currentVendorDetail && currentVendorDetail.Billing) {
      contact = `${currentVendorDetail.Billing.FirstName} ${currentVendorDetail.Billing.LastName}`;
      phone = currentVendorDetail.Billing.Telephone;
      billingAddress = this.getBillingAddress();
    }
    return (
      <div>
        <Row className='mb0'>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="vendor_no" />
              <span style={{ color: 'red' }} >*</span>
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Vendor' component={Selection} matchPos="any" options={vendorNumOptions} />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="vendor_name" />
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Vendor' component={Selection} matchPos="any" options={vendorNameOptions} />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="phone" />
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Vendor' component={Selection} matchPos="any" options={vendorPhoneOptions} />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="note" />
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Vendor' component={Selection} options={vendorDescOptions} />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-3'>
              <Translate value="contact" />:
            </label>
            <Col sm={9}>
              {contact}
            </Col>
            <label className='col-sm-3'>
              <Translate value="address" />:
            </label>
            <Col sm={9}>
              {billingAddress[0]}
              <br />
              {billingAddress[1]}
            </Col>
          </Col>
        </Row>
      </div>
    );
  }

  renderInvoiceDateRadio = (props) => {
    const fromDate = 'FromDate';
    const toDate = 'ToDate';
    return (
      <ButtonToolbar className='mb-md radio-filter-buttons'>
        <Button bsStyle={this.getBsStyle(props.input.value, 'all')}>
          <div className='radio'>
            <label htmlFor='all-radio-filter'>
              <input
                {...props.input}
                type='radio'
                id='all-radio-filter'
                className='statusFilterRadios'
                value='all'
                checked={props.input.value === 'all'}
              />
              <Translate value="all" />
            </label>
          </div>
        </Button>
        <Button bsStyle={this.getBsStyle(props.input.value, 'range')}>
          <div className="radio">
            <label htmlFor="dateRange-radio-filter">
              <input
                {...props.input}
                type='radio'
                id='dateRange-radio-filter'
                className='statusFilterRadios'
                value='range'
                checked={props.input.value === 'range'}
              />
              <Translate value="date_range" />
            </label>
          </div>
        </Button>
        {this.renderDatePicker(fromDate, 'Start')}
        {this.renderDatePicker(toDate, 'End')}
      </ButtonToolbar>
    );
  }

  handleCheckNumChange(e) {
    const stringValue = "" + e.target.value;
    if (this.state.checkNumbers.includes(stringValue)) {
      this.setState({
        checkNumbersInputHasWarning: true,
      });
    } else {
      this.setState({
        checkNumbersInputHasWarning: false,
      });
    }
  }

  renderCheckNum() {
    return (
      <div>
        <Field name="CheckNum" component={InputField} onChange={this.handleCheckNumChange.bind(this)} />
        {this.state.checkNumbersInputHasWarning && <p style={{position: "absolute", top: "23px"}}>Reminder: Check num already exists</p>}
      </div>
    );
  }

  renderCredits() {
    if (this.props.creditsIsLoading && !this.props.creditsError) {
      return <Spinner />;
    } else if (this.props.creditsError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
    return (
      <Field name="Credits" component={MultiSelection} options={creditOptions} />
    );
  }

  renderInvoices() {
    if (this.props.invoicesIsLoading && !this.props.invoicesError) {
      return <Spinner />;
    } else if (this.props.invoicesError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            {JSON.stringify(this.props.invoicesError)}
          </div>
        </ContentWrapper>
      );
    }
    const { invoices } = this.state;
    return (
      <APReceiveTable
        rows={invoices}
        moveInvoices={this.moveInvoices}
        from='invoices'
        to='selectedInvoices'
      />
    );
  }

  renderSelectedInvoices() {
    const { selectedInvoices } = this.state;
    return (
      <APReceiveTable
        ref={(selectedTable) => { this.selectedTable = selectedTable; }}
        rows={selectedInvoices}
        moveInvoices={this.moveInvoices}
        from='selectedInvoices'
        to='invoices'
        handleCellUpdate={this.handleDiscountCellChange}
      />
    );
  }

  renderWaiveInputField = (props) => {
    const { meta: { touched, error }, className } = props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    return (
      <div>
        <Input
          {...props.input}
          className={inputClass}
          type='text'
          onChange={(event) => {
            props.input.onChange(event);
            this.handleWaiveInputChange(event);
          }}
          disabled={props.disabled}
        />
        {touched && error && <span className="parsley-error-message">{error}</span>}
      </div>
    );
  }

  renderResponse() {
    const { apCreated, apCreateError, apIsCreating } = this.props;
    if (apCreated) {
      return (
        <ContentWrapper>
          <div className='alert alert-success'>Success!</div>
        </ContentWrapper>
      );
    } else if (apIsCreating && !apCreateError) {
      return (
        <ContentWrapper>
          <div className='alert alert-info'>
            ...<Translate value="reading_data" />
          </div>
        </ContentWrapper>
      );
    } // else if (apCreateError) {
    //   return (
    //     <ContentWrapper>
    //       <div className='alert alert-danger'>
    //         <Translate value="something_unexpected_happened" />
    //       </div>
    //     </ContentWrapper>
    //   );
    // }
    return <ContentWrapper />;
  }

  render() {
    const { handleSubmit, pristine, method, submitting } = this.props;
    const paymentMethodIsCredit = (method === 'Credit' || (method && method.value === 'Credit'));
    const twoDecimalZero = (0).toFixed(2);
    const discount = parseFloat(this.props.discount) || twoDecimalZero;
    const totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
    const balance = (totalAmount - discount).toFixed(2) || twoDecimalZero;
    const waiveAmount = this.state.waiveAmount;
    const totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
    const finalBalance = (balance - waiveAmount - totalPayment).toFixed(2) || twoDecimalZero;

    return (
      <ContentWrapper>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="ar_slashsign_ap" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active='true'>
              <Translate value="account_payable" />
            </Breadcrumb.Item>
          </Breadcrumb> {/* End Navigation Trail */}
          <Grid id='AP-detail'>
            <ButtonToolbar>
              <Button
                bsStyle='success'
                type='submit'
                disabled={pristine || submitting}
              >
                <em className="fa fa-save" /><Translate value="save" />
              </Button>
              <Button
                bsStyle='danger'
                type='button'
                onClick={() => (
                  document.referrer === window.location.href
                    ? this.props.router.push('/AP')
                    : this.props.router.goBack()
                )}
              >
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
            </ButtonToolbar>
            <Panel id='vendors'>
              { this.renderVendors() }
            </Panel>
            <Panel>
              <Row id='date-range-picker' className='form-horizontal'>
                <div className='col-sm-7'>
                  <label className='floatLeft'>
                    <Translate value="receive_date" />
                  </label>
                  <Field name='InvoiceDate' component={this.renderInvoiceDateRadio} />
                </div>
              </Row>
              <Row>
                <Col sm={6}>
                  { this.renderInvoices() }
                </Col>
                <Col sm={6}>
                  { this.renderSelectedInvoices() }
                </Col>
              </Row>
            </Panel>
            <Panel id='check-out-information'>
              <Row>
                <Col sm={1}>
                  <label className='text-nowrap inlineLabel' >
                    <Translate value="payment_method" />
                    <span className='asteriksReq'>*</span>
                  </label>
                </Col>
                <Col sm={2}>
                  <Field name='Method' className='select-menu-drop-up' component={Selection} options={PaymentMethodOptions} />
                </Col>
                <Col sm={1}>
                  <label className='inlineLabel' >
                    <Translate value="check_number" />
                  </label>
                </Col>
                <Col sm={2}>
                  { paymentMethodIsCredit && this.renderCredits() }
                  { !paymentMethodIsCredit && this.renderCheckNum() }
                </Col>
                {/* Waive section */}
                <Col sm={2}>
                  <Row>
                    <Col sm={3}>
                      <label className='inlineLabel' >
                        <Translate value="waive" />
                      </label>
                    </Col>
                    {/*
                      <Col sm={2}>
                        <Field name='Waive' component={this.renderWaiveCheckbox} />
                      </Col>
                    */}
                    <Col sm={6} smOffset={1}>
                      <Field name='WaiveAmount' component={this.renderWaiveInputField} />
                    </Col>
                  </Row>
                </Col>
                {/* End waive section */}
                <Col xs={2}>
                  <Row>
                    <Col xs={4}>
                      <label>
                        <Translate value="payment_date" />
                        <span className="asteriksReq text-nowrap">*</span>
                      </label>
                    </Col>
                    <Col xs={7}>
                      <Field name='PaymentDate' component={DatePicker} dropUp maxDate={new Date()} />
                    </Col>
                  </Row>
                </Col>
                <Col sm={1}>
                  <label>
                    <Translate value="balance" /> :
                  </label>
                </Col>
                <Col sm={1}>
                  <label>
                    {'$'+numberWithCommas(balance)}
                  </label>
                </Col>
              </Row>
              <Row>
                <label className='col-sm-1 inlineLabel' >
                  <Translate value="account" />
                  <span style={{ color: 'red' }} >*</span>
                </label>
                <Col sm={2}>
                  <AccountDropdown className='select-menu-drop-up'/>
                </Col>
                <label className='col-sm-1 text-nowrap inlineLabel' >
                  <Translate value="pay_amount" />
                  <span className='asteriksReq'>*</span>
                </label>
                <Col sm={2}>
                  <Field name='TotalPayment' component={InputField} />
                </Col>
                <Col sm={4}>
                  <Row>
                    <Col sm={2}>
                      <label className='inlineLabel' >
                        <Translate value="discount" />
                      </label>
                    </Col>
                    <Col sm={3}>
                      <Field name='Discount' component={this.renderInputField} placeholder='$' disabled />
                    </Col>
                  </Row>
                </Col>
                <label className='col-sm-1'>
                  <Translate value="final_balance" /> :
                </label>
                <label className='col-sm-1'>
                  {'$'+numberWithCommas(finalBalance)}
                </label>
              </Row>
              <div className='horizontal-divider' />
              <Row /* id='hint' */>
                <Col sm={1}>
                  <label className='inlineLabel' >
                    <Translate value="note" />
                  </label>
                </Col>
                <Col sm={5}>
                  <Field name='Note' component={InputField} />
                </Col>
                <Col sm={3} smOffset={2}>
                  {/* <ButtonToolbar id='apply-button'>
                    <Button
                      bsStyle='primary'
                      type='submit'
                      disabled={pristine || submitting}
                    >
                      <Translate value="apply" />
                    </Button>
                  </ButtonToolbar> */}
                </Col>
              </Row>
            </Panel>
            <Row>
              {this.renderResponse()}
            </Row>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}

export default CreateAP;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/CreateAP/createAP.jsx